import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ToggleFeature, features } from 'features/ToggleFeature'

const RegulationPage = ({ regulationCms }) => {
  return <ToggleFeature feature={features.RegulationComponent} regulationCms={regulationCms} />
}

RegulationPage.propTypes = {
  regulationCms: PropTypes.object
}

const mapStateToProps = ({
  mainMenu,
  oidc: {
    user: { profile }
  }
}) => ({
  regulationCms: (profile
    ? mainMenu[profile['custom:catalog_id']]
      ? mainMenu[profile['custom:catalog_id']]
      : mainMenu['default']
    : mainMenu['default']
  ).regulation
})

export default withRouter(connect(
  mapStateToProps,
  null
)(RegulationPage))



// WEBPACK FOOTER //
// ./src/features/Regulation/RegulationPage.js